import ColorPicker from './ColorPicker'

const XColorPicker = {
  install(Vue) {
    Vue.component(ColorPicker.name, ColorPicker)
  }
}

export default XColorPicker
